import React from 'react';
import { Select } from 'antd';
import styles from './disabledSelect.scss';

const DisabledSelect = ({ value, options, placeholder }) => (
  <Select
    className={styles.select}
    disabled
    placeholder={value
      ? options.find(o => o.value === value).title
      : placeholder}
  />
);

DisabledSelect.defaultProps = {
  value: null,
};

export default DisabledSelect;



// WEBPACK FOOTER //
// ./src/components/FormControls/IndexSelect/DisabledSelect/index.tsx